<template>
    <li class="p-error">
        <small><slot /></small>
    </li>
</template>